import ncmStatsPlot from "../../../../content/posts/data-release-notes/gm24385_ncm_preview_2023.12/ncm_plots.jsx";
import * as React from 'react';
export default {
  ncmStatsPlot,
  React
};